// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ta-0";
export var checkoutRateBadgeLink = "_ta-1";